import { useState } from 'react'
import IconBox from '../../../components/common/icon-box'
import Input from '../../../components/common/input'
import { useUser } from '../../../common/hooks/auth/useUser'
import { useTranslation } from '../../../useTranslation'
import Button from '../../../components/common/button'
import Modal from '../../../components/common/modal/modal'

const UpdateEmail = () => {
    const [showModal, setShowModal] = useState(false)
    const { user } = useUser()
    const { t } = useTranslation()

    return (
        <>
            <Modal open={showModal} onClose={() => setShowModal(false)}>
                <p>{t('myAccount.personalData.updateEmailSupportInfo')}</p>
                <div className="pt-3 gap-3 flex justify-center">
                    <Button type="squareBlue" text={t('ok')} onClick={() => setShowModal(false)} />
                </div>
            </Modal>
            <IconBox icon={'envelope'}>
                <div className="pt-12 pb-6 px-2 max-tablet:pt-10">
                    <p className="font-bold text-xl text-left leading-none max-tablet:text-base">
                        {t('email') + ':'}
                        <span className="text-black text-xl font-light pl-1 max-tablet:text-base">{user?.email}</span>
                    </p>
                    <div className="flex flex-col mb-3 pt-3 max-tablet:pt-2">
                        <div className="w-full mb-3">
                            <Input label={t('myAccount.personalData.newEmail')} required>
                                <input className="text-input" type="email" placeholder={t('myAccount.personalData.newEmail')} />
                            </Input>
                        </div>
                        <div className="w-full mb-3">
                            <Input label={t('myAccount.personalData.confirmEmail')} required>
                                <input className="text-input" type="email" placeholder={t('myAccount.personalData.confirmEmail')} />
                            </Input>
                        </div>
                        <div className="w-full">
                            <Input label={t('password')} required>
                                <input className="text-input" type="password" placeholder={t('password')} />
                            </Input>
                        </div>
                    </div>

                    <div className="flex justify-center mt-14 max-tablet:mt-5">
                        <Button type="squareBlue" icon="check" text={t('save')} onClick={() => setShowModal(true)} />
                    </div>
                </div>
            </IconBox>
        </>
    )
}

export default UpdateEmail
